import EntitlementDetail from "./EntitlementDetail";

export default EntitlementDetail;
